import { useEffect, useState } from "react";
import { useTtvContext } from "api/settings/ttv/TtvProvider";
import { FormattedMessage } from "react-intl";
import { HandleModaleBO } from "components/bo/HandleModaleBO";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TableManager } from "components/bo/admin-table/TableManager";
import { ACTIONS, ENTITIES } from "constants/constants";
import { navigateView, navigateEdit, navigateToParent } from "utils/boHelper";
import { isHexa } from "utils/functions";
import HexaColor from "core/hexa-color/HexaColor";
import Button from "core/buttons/button/Button";

export default function AdminTtv({ action }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const {
    ttvListGetter,
    ttvCreate,
    ttvByIdGetter,
    ttvDeleteById,
    ttvList,
    ttvPerId,
    ttvUpdateById,
  } = useTtvContext();

  const ttvForm = [
    { col: "en", mandatory: true, isMissingValue: null },
    { col: "fr", mandatory: true, isMissingValue: null },
    { col: "tag", mandatory: true, isMissingValue: null },
    { col: "hexa", mandatory: true, isMissingValue: null },
  ];

  const [deleteData, setDeleteData] = useState(null);

  useEffect(() => {
    ttvListGetter();
  }, [ttvListGetter]);

  useEffect(() => {
    if (id) {
      ttvByIdGetter(id);
    }
  }, [id]);

  const handleDelete = async (ttvCoef) =>
    setDeleteData(ttvList.find((e) => e.id === ttvCoef));

  const validateDelete = async (ttvCoef) => {
    try {
      await ttvDeleteById(ttvCoef);
    } catch (error) {
      console.error(error);
    }
  };
  const handleCreate = (payload) => {
    try {
      ttvCreate(payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };
  const handleEdit = (payload) => {
    try {
      ttvUpdateById(payload.id, payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };
  const formatList = (list) =>
    list.map((elm) => ({
      ...elm,
      hexa: isHexa(elm?.hexa) ? <HexaColor value={elm.hexa} /> : "",
    }));
  const formatTvv = (ttv) => ({
    ...ttv,
    hexa: isHexa(ttv.hexa) ? <HexaColor value={ttv.hexa} /> : "",
  });
  // Todo gestion droits admin
  return (
    <div>
      {action === ACTIONS.LIST && (
        <div className="flex">
          <Button
            className="btn-hover-color"
            size="large"
            color="blue"
            onClick={() => navigateView("new", navigate, location)}
          >
            <FormattedMessage
              id={"admin_create_new"}
              defaultMessage={"Nouveau"}
            />
          </Button>
        </div>
      )}
      <br />
      <TableManager
        action={action}
        entity={ENTITIES.TTV}
        entityPerId={ttvPerId}
        formattedEntity={formatTvv(ttvPerId)}
        list={formatList(ttvList)}
        inputs={ttvForm}
        navigateEdit={(propsId) => navigateEdit(propsId, navigate, location)}
        navigateView={(propsId) => navigateView(propsId, navigate, location)}
        handleCreate={handleCreate}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />
      <div id="modalDelete">
        <HandleModaleBO
          setDeleteData={setDeleteData}
          validateDelete={validateDelete}
          deleteData={deleteData}
          entity={ENTITIES.TTV}
        />
      </div>
    </div>
  );
}
